var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 10.75 4 10.75 5.5 9.25C6.25 8.5 4 8.5 4 4.75C4 2.25025 4.99975 1 7 1C9.00025 1 10 2.25025 10 4.75C10 8.5 7.75 8.5 8.5 9.25C10 10.75 13 10.75 13 13",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.75V5.5",
    stroke: "#888281",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 8.5C14.1642 8.5 14.5 8.16421 14.5 7.75C14.5 7.33579 14.1642 7 13.75 7C13.3358 7 13 7.33579 13 7.75C13 8.16421 13.3358 8.5 13.75 8.5Z",
    fill: "#888281",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/manage-users.7eb169c2917c505a01e9190b4e9ace00.svg";
export { ForwardRef as ReactComponent };